import React from 'react';
import IconsService from 'external-services/icons-service/icons.service';
import { IconTypes } from 'external-services/icons-service/icons.types';
import style from './GlobalBookingSearchModal.module.css';

export default function GlobalSearchErrorState({ onRetry }: {
    onRetry: () => void;
}) {
    const WarningIcon = IconsService.getIcon(IconTypes.warning);
    const RetryIcon = IconsService.getIcon(IconTypes.bookings);

    return (
        <div className={style.errorState}>
            <div className={style.errorIcon}>
                <WarningIcon />
            </div>
            <h3 className={style.errorTitle}>Search Error</h3>
            <p className={style.errorMessage}>
                There was a problem searching for bookings. Please check your connection and try again.
            </p>
            <button
                className={style.retryButton}
                onClick={onRetry}
                type="button"
            >
                <RetryIcon className={style.retryIcon} />
                Retry Search
            </button>
        </div>
    );
}

